module.exports = __webpack_public_path__ + "img/case_pic03.0a8c838c.png";